import React from 'react';
import { relocationPages } from '../../data/relocation';
import SEO from '../../components/SEO';

const RelocationBanking = () => {
  const pageData = relocationPages.banking;

  return (
    <div className="min-h-screen bg-[#F9F6EF]">
      <SEO
        title="Banking in Mexico"
        description="How to open a bank account in Mexico as an expat. Recommended banks, required documents, and tips for managing finances across the border."
        path="/relocation/cdmx/banking"
      />
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#F9F6EF] border-b border-[#F4ECD8]">
        <div className="container-wide mx-auto px-8 py-5">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center gap-3">
              <img src="https://res.cloudinary.com/des9fk8et/image/upload/e_trim,f_auto,q_auto:good/mundalo/brand/mundalo-logo-white.png" alt="Mundalo" className="block h-7 w-[140px] object-contain object-left" />
            </a>
            <nav className="hidden md:flex items-center gap-8">
              <a href="/" className="text-sm font-medium text-[#1A5C6E] hover:text-[#2CA8A0] transition">Home</a>
              <a href="/relocation/cdmx" className="text-sm font-medium text-[#0A1F2E]">Relocation</a>
              <a href="/contact" className="btn-primary text-xs px-6 py-3">Contact</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="section">
        <div className="container-wide mx-auto">
          <a href="/relocation/cdmx" className="inline-block text-sm font-medium text-[#5A6B73] mb-6 hover:text-[#2CA8A0] transition">
            ← Back to Relocation Hub
          </a>
          <p className="label mb-4">Relocation Hub</p>
          <h1 className="heading-xl mb-6">{pageData.title}</h1>
          <p className="body-lg max-w-3xl">{pageData.description}</p>
        </div>
      </section>

      {/* Topics */}
      <section className="section-sm bg-[#FFFFFF]">
        <div className="container-narrow mx-auto">
          <div className="space-y-8">
            {pageData.topics.map((topic, idx) => (
              <div key={idx} className="bg-[#FFFFFF] border border-[#E0D6B8] p-6">
                <h3 className="heading-sm mb-4">{topic.title}</h3>
                <p className="body-md">{topic.content}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Practical Tips */}
      <section className="section">
        <div className="container-narrow mx-auto">
          <h2 className="heading-lg mb-8 text-center">Practical Tips</h2>
          
          <div className="space-y-6">
            <div className="border-b border-[#E0D6B8] pb-6">
              <h3 className="heading-sm mb-3">ATM Usage</h3>
              <p className="body-md">Use bank ATMs inside branches for safety. Withdraw in pesos to avoid dynamic currency conversion. Daily limits typically 8,000-10,000 MXN.</p>
            </div>
            <div className="border-b border-[#E0D6B8] pb-6">
              <h3 className="heading-sm mb-3">Currency Exchange</h3>
              <p className="body-md">Avoid airport exchange. Use bank ATMs or established casas de cambio in commercial areas. Wise and Revolut offer competitive exchange rates.</p>
            </div>
            <div className="border-b border-[#E0D6B8] pb-6">
              <h3 className="heading-sm mb-3">Paying Bills</h3>
              <p className="body-md">Most utilities can be paid at OXXO convenience stores or online. Set up automatic payments through Mexican bank accounts when possible.</p>
            </div>
            <div>
              <h3 className="heading-sm mb-3">Tax Obligations</h3>
              <p className="body-md">Mexican tax residents are taxed on worldwide income. US citizens have additional FBAR and FATCA requirements. Work with a cross-border tax professional.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="section-sm bg-[#FFFFFF]">
        <div className="container-narrow mx-auto text-center">
          <p className="body-sm text-[#5A6B73]">
            Tax and financial information is for general guidance only. Consult qualified tax and financial professionals for advice specific to your situation.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="section-sm bg-[#FFFFFF] border-t border-[#F4ECD8]">
        <div className="container-narrow mx-auto text-center">
          <h2 className="heading-lg mb-4">Need Financial Guidance?</h2>
          <p className="body-md mb-8">
            Our relocation plans include introductions to cross-border tax and financial professionals.
          </p>
          <a href="/relocation/blueprint" className="btn-primary">View Relocation Plans</a>
        </div>
      </section>

      {/* Footer */}
      <footer className="section-sm border-t border-[#F4ECD8]">
        <div className="container-wide mx-auto text-center">
          <img src="https://res.cloudinary.com/des9fk8et/image/upload/e_trim,f_auto,q_auto:good/mundalo/brand/mundalo-logo-white.png" alt="Mundalo" className="block h-7 w-[140px] object-contain object-left" />
          <p className="body-sm">© {new Date().getFullYear()} Mundalo. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default RelocationBanking;
